<template>
  <div>
    <div>
      <h1>
        Fetching custom, cost-optimized routes
        <span v-if="fromLocality && toLocality">
      from Philadelphia to Omaha
      </span>
        <span v-else>
       ...
      </span>
      </h1>
      <h2>This can take up to one minute.</h2>
    </div>
    <b-loading :is-full-page="false" :active="true"></b-loading>
  </div>
</template>

<script>
import axios from 'axios';
import itineraries from '../itineraries';

export default {
  name: 'Fetch',
  props: ['fromLocality', 'toLocality', 'searchId'],
  data() {
    return {
      isLoading: true,
    };
  },
  mounted() {
    const self = this;
    setTimeout(() => {

      self.isLoading = false;
      self.$router.push({
        name: 'Results',
        params: {
          searchId: self.searchId,
          fromLocality: self.fromLocality,
          toLocality: self.toLocality,
          direction: 'departing',
          itineraries: itineraries.data
        },
      });
    }, 2500);
    // axios.post('http://www.zegmentodemo.com:9999/itinerary', { search_id: this.searchId })
    //   .then((response) => {
    //
    //   })
    //   .catch((error) => {
    //     self.isLoading = false;
    //     self.alertItineraryError();
    //   });
  },
  methods: {
    alertItineraryError() {
      const self = this;
      this.$dialog.alert({
        title: 'Error',
        message: 'Something went wrong.. please try again.',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: _val => self.$router.back(),
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Fetch.vue